import { render, staticRenderFns } from "./ossStorageLineChart.vue?vue&type=template&id=1dc121b6&scoped=true"
import script from "./ossStorageLineChart.vue?vue&type=script&lang=js"
export * from "./ossStorageLineChart.vue?vue&type=script&lang=js"
import style0 from "./ossStorageLineChart.vue?vue&type=style&index=0&id=1dc121b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc121b6",
  null
  
)

export default component.exports